<template>
	<div class="DataView-atten">
		<iframe class="iframe" ref="iframe" :src="iframeSrc" frameborder="0"></iframe>
	</div>
</template>
<script>
import { getLeaveBigScreenData } from '../api/modules/big-screen';
import { publicAssetUrl } from '@/utils/publicAssetUrl';
export default {
	data: () => {
		return {
			window: null,
			timer: null,
			departmentId: '0',
			date: '',
			isAdmin: 0,
      nowDate: '',
		}
	},
	computed: {
		/** build:api 下须带 /ui 前缀。创建于 2026-08-12 */
		iframeSrc() {
			return publicAssetUrl('static/leave/index.html');
		}
	},
	mounted() {

		// 获取 URL 参数
		const queryString = window.location.search
		const urlParams = new URLSearchParams(queryString)
		this.departmentId = urlParams.get('departmentId') || '99'
		if (this.departmentId == '0') {
			this.departmentId = '99'
		}

		// if (window.localStorage.user) {
		// 	var user = JSON.parse(window.localStorage.user)
		// 	this.departmentId = user.DepartmentId || '0' // 获取参数
		// } else {
		// 	// 获取 URL 参数
		// 	const queryString = window.location.search
		// 	const urlParams = new URLSearchParams(queryString)
		// 	this.departmentId = urlParams.get('departmentId') || '99'
		// 	if (this.departmentId == '0') {
		// 		this.departmentId = '99'
		// 	}
		// }

		// if (this.departmentId == '0') {
		// 	// 获取 URL 参数
		// 	const queryString = window.location.search
		// 	const urlParams = new URLSearchParams(queryString)
		// 	this.departmentId = urlParams.get('departmentId') || '99'
		// 	if (this.departmentId == '0') {
		// 		this.departmentId = '99'
		// 	}
		// }

		this.initWindow()
		this.$nextTick(() => {
			this.initData()
		})
	},
	methods: {
		initWindow() {
			if (this.$refs.iframe) {
				let iframe = this.$refs.iframe
				iframe.addEventListener('load', () => {
					this.window = iframe.contentWindow
					this.window.onSelectDate = this.onSelectDate
				})
			} else {
				setTimeout(() => {
					this.initWindow()
				}, 100)
			}
		},
		async initData() {
			if (!this.window) {
				setTimeout(() => {
					this.initData()
				}, 100)
				return
			}

      let temp = this.formateDate()
			if (!this.nowDate) {
				this.nowDate = temp
			} else if (this.nowDate != temp) {
				window.location.reload()
				return
			}

			if (this.timer) {
				clearTimeout(this.timer)
				this.timer = null
			}
			var params = {
				departmentId: this.departmentId,
				date: this.date,
				isAdmin: this.isAdmin,
			}
			getLeaveBigScreenData(params).then(data => {
				if (data.success) {
					this.window.$LargeScreenData = data.response;
				} else {
					this.window.$LargeScreenData = null;
				}
			}).catch(e => {
				_this.logining = false;
				_this.loginStr = "重新登录";
			});

			this.timer = setTimeout(() => {
        this.timer = null
				this.initData()
			}, 30 * 1000 * 10)
		},
		onSelectDate(val) {
			this.date = val
			this.$nextTick(() => {
				this.initData()
			})
		},
    formateDate(fmt = 'yyyy-mm-dd', date = '') {
			if (!date) {
				date = new Date()
			}

			try {
				if (typeof date == 'string') {
					date = date.replace(/-/g, '/').replace(/T/g, ' ')
					if (date.indexOf('/') == -1) {
						date = new Date(parseFloat(date))
					}
					date = new Date(date)
				} else if (typeof date == 'number') {
					date = new Date(date)
				}
			} catch (error) {
				console.log('时间格式化出错', error)
				date = new Date()
			}

			let ret
			let weak = (function (date) {
				let days = date.getDay()
				let weekArrTxt = [
					'星期天',
					'星期一',
					'星期二',
					'星期三',
					'星期四',
					'星期五',
					'星期六',
				]
				let weekArrTxt2 = [
					'周日',
					'周一',
					'周二',
					'周三',
					'周四',
					'周五',
					'周六',
				]
				return [weekArrTxt[days], weekArrTxt2[days]]
			})(date)
			const opt = {
				'y+': date.getFullYear().toString(), // 年
				'm+': (date.getMonth() + 1).toString(), // 月
				'd+': date.getDate().toString(), // 日
				'H+': date.getHours().toString(), // 时
				'M+': date.getMinutes().toString(), // 分
				'S+': date.getSeconds().toString(), // 秒
				// 有其他格式化字符需求可以继续添加，必须转化成字符串
				'W+': weak[0],
				'w+': weak[1],
			}
			for (let k in opt) {
				ret = new RegExp('(' + k + ')').exec(fmt)
				if (ret) {
					fmt = fmt.replace(
						ret[1],
						ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
					)
				}
			}
			return fmt
		},
	},
}
</script>
<style>
.DataView-atten {
	overflow: hidden;
	width: 100vw;
	height: 100vh;
}

.iframe {
	width: 100%;
	height: 100%;
}
</style>
